export const gamingSurveyQuestions = [
  {
    questionText: "1. How was your overall experience?",
    type: "textarea",
    responseKey: "question1",
  },
  {
    questionText: "2. Rate the app's user interface experience.",
    type: "textarea",
    responseKey: "question2",
  },
  {
    questionText: "3. Please rate the app from 1 to 5.",
    type: "rate",
    responseKey: "question3",
    description: "1 = Strongly Agree, 5 = Strongly Disagree",
  },
  {
    questionText: "4. How do you find the gaming features? Select one option.",
    type: "multiple-choice",
    responseKey: "question4",
    options: ["Very Impressive", "Good", "Average", "Needs Improvement"],
  },
  {
    questionText:
      "5. Do you have any other feedback for us? We'd love to hear from you! (Optional)",
    type: "textarea",
    responseKey: "feedback",
  },
];

export const eventsSurveyQuestions = [
  {
    questionText: "1. How would you rate the overall event experience?",
    type: "textarea",
    responseKey: "question1",
  },
  {
    questionText: "2. How satisfied are you with the event organization?",
    type: "textarea",
    responseKey: "question2",
  },
  {
    questionText: "3. Please rate the event from 1 to 5.",
    type: "rate",
    responseKey: "question3",
    description: "1 = Strongly Agree, 5 = Strongly Disagree",
  },
  {
    questionText: "4. What aspect of the event did you enjoy the most?",
    type: "multiple-choice",
    responseKey: "question4",
    options: ["Speakers", "Activities", "Networking", "Venue", "Other"],
  },
  {
    questionText:
      "5. Do you have any suggestions for future events? (Optional)",
    type: "textarea",
    responseKey: "feedback",
  },
];

export const loyaltySurveyQuestions = [
  {
    questionText: "1. How satisfied are you with the loyalty rewards?",
    type: "textarea",
    responseKey: "question1",
  },
  {
    questionText: "2. How easy is it to redeem your loyalty points?",
    type: "textarea",
    responseKey: "question2",
  },
  {
    questionText: "3. Please rate your loyalty experience from 1 to 5.",
    type: "rate",
    responseKey: "question3",
    description: "1 = Strongly Agree, 5 = Strongly Disagree",
  },
  {
    questionText:
      "4. How likely are you to recommend our loyalty program to others?",
    type: "multiple-choice",
    responseKey: "question4",
    options: ["Very Likely", "Likely", "Neutral", "Unlikely", "Very Unlikely"],
  },
  {
    questionText:
      "5. Do you have any additional feedback regarding the loyalty program? (Optional)",
    type: "textarea",
    responseKey: "feedback",
  },
];

export const generalSurveyQuestions = [
  {
    questionText: "1. How satisfied are you with our service overall?",
    type: "textarea",
    responseKey: "question1",
  },
  {
    questionText: "2. What aspect of our service do you like the most?",
    type: "textarea",
    responseKey: "question2",
  },
  {
    questionText: "3. Please rate our service from 1 to 5.",
    type: "rate",
    responseKey: "question3",
    description: "1 = Strongly Agree, 5 = Strongly Disagree",
  },
  {
    questionText: "4. How likely are you to recommend our service to others?",
    type: "multiple-choice",
    responseKey: "question4",
    options: ["Very Likely", "Likely", "Neutral", "Unlikely", "Very Unlikely"],
  },
  {
    questionText: "5. Do you have any suggestions for improvement? (Optional)",
    type: "textarea",
    responseKey: "feedback",
  },
];

export const offersSurveyQuestions = [
  {
    questionText: "How easy was it to opt into the Capture & Share promo?",
    type: "multiple-choice",
    responseKey: "Question1",
    options: [
      "Very easy, no issues at all",
      "Moderate, a few minor challenges",
      "Difficult, faced several issues",
    ],
  },
  {
    questionText:
      "How smooth was the process of purchasing Mashup bundles and accumulating points?",
    type: "multiple-choice",
    responseKey: "Question2",
    options: [
      "Very smooth, no challenges",
      "Fairly easy, but could be improved",
      "Difficult, had several issues",
    ],
  },
  {
    questionText: "How clear was the points accumulation process?",
    type: "multiple-choice",
    responseKey: "Question3",
    options: [
      "Very clear, easy to understand",
      "Somewhat clear, but needed more info",
      "Confusing, difficult to understand",
    ],
  },
  {
    questionText:
      "How engaging and competitive was the leaderboard experience?",
    type: "multiple-choice",
    responseKey: "Question4",
    options: [
      "Very exciting and competitive",
      "Somewhat engaging, but could improve",
      "Not exciting, felt unnecessary",
    ],
  },
  {
    questionText:
      "How satisfied are you with the overall Capture & Share promo experience?",
    type: "multiple-choice",
    responseKey: "Question5",
    options: [
      "Very satisfied",
      "Somewhat satisfied, but could improve",
      "Not satisfied, felt unnecessary",
    ],
  },
  {
    questionText:
      "How likely are you to recommend MTN Pulse based on this Capture & Share promo experience (NPS score on a scale of 1-10)?",
    type: "rate",
    responseKey: "Question6",
    description: "1 = Not at all likely, 10 = Extremely likely",
  },
];

// export const offersSurveyQuestions = [
//   {
//     questionText: "How easy was it to generate your free ticket?",
//     type: "multiple-choice",
//     responseKey: "Quetion1",
//     options: [
//       "Very easy, no issues at all",
//       "Moderate, a few minor challenges",
//       "Difficult, faced several issues",
//     ],
//   },
//   {
//     questionText:
//       "How would you rate the ticket collection process at the MTN Customer Experience Center?",
//     type: "multiple-choice",
//     responseKey: "Question2",
//     options: [
//       "Very organized and quick",
//       "Adequate, but could be better",
//       "Unorganized and slow",
//     ],
//   },
//   {
//     questionText: "How was your experience collecting popcorn and drinks?",
//     type: "multiple-choice",
//     responseKey: "Question3",
//     options: [
//       "Very smooth and enjoyable",
//       "Average, could be improved",
//       "Difficult or frustrating",
//     ],
//   },
//   {
//     questionText: "How enjoyable was the “Spin the Wheel” activity?",
//     type: "multiple-choice",
//     responseKey: "Question4",
//     options: [
//       "Very enjoyable, loved the freebies",
//       "Somewhat fun, but not very exciting",
//       "Not enjoyable, felt unnecessary",
//     ],
//   },
//   {
//     questionText:
//       "How satisfied were you with the overall movie pre-screening experience?",
//     type: "multiple-choice",
//     responseKey: "Question5",
//     options: [
//       "Extremely satisfied, everything was great",
//       "Satisfied, but some areas could improve",
//       "Dissatisfied, issues with quality or comfort",
//     ],
//   },
//   {
//     questionText:
//       "How likely are you to recommend MTN Pulse based on this movie pre-screening experience (NPS score on a scale of 1-10)?",
//     type: "rate",
//     responseKey: "Question6",
//     rates: [
//       "Promoters (9-10): Highly likely to recommend",
//       "Passives (7-8): Likely, but with some reservations",
//       "Detractors (0-6): Unlikely to recommend",
//     ],
//   },
// ];
